import React from "react";
import {
    Navigate,
} from "react-router-dom";
// import ContainerRedirect from "../../../../../pages/lib/page-redirect";


const ReportListComponent = React.lazy(() => import("../../../../../components/reports/components/list/page"));

export const workflowReportRoute = [
    {
        path: 'list',
        element: <ReportListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/workflow/reports/list" />
    },
];